import BaseCatalogViewModel from 'Common/baseCatalogModel';

class ViewModel extends BaseCatalogViewModel {
    constructor() {
        super();
    }

    searchParams() {
        return Object.assign(super.searchParams(), { categoryId: this.model.Id() });
    }

    pageId() {
        return this.model.Id();
    }
}

var vm = new ViewModel();
(async () => {
    await vm.init();
})().catch(err => console.error(err));

window.vm = vm;